import articleApi from 'api/article';
import ArticleContents from 'components/articles/articleContents';
import ArticleFav from 'components/articles/articleFav';
import EmailModal from 'components/layout/emailModal';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import PageFooter from 'components/layout/pageFooter';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SearchField from 'components/searchField';
import session from 'services/sessionService';
import {emailSendingTypes} from 'helpers/constants';
import {intlShape, injectIntl} from 'react-intl';

let render = (container, params) => {
  console.info('[UI.page.encyclopediaArticle] rendering page');
  ReactDOM.render(<IntlWrapper>
    <WrappedEncyclopediaArticlePage slug={params.articleSlug}/>
  </IntlWrapper>, container);
  events.publish('page-change', {page: 'encyclopediaArticle'});
};

console.info('[UI.page.encyclopediaArticle] register route');
router.rr.add([{path: 'encyclopedia/:articleSlug', handler: routeUtils.requireAuth(render)}]);

// Page object
class EncyclopediaArticlePage extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    topic: '',
    query: '',
    article: undefined,
    topics: [],
  };

  componentDidMount() {
    this.fetchCurrentArticle(this.props.slug);
    articleApi.getEncyclopediaTopics().then(topics => {
      this.setState({topics: topics});
    });
  }

  componentWillReceiveProps(newProps) {
    this.fetchCurrentArticle(newProps.slug);
  }

  changeHandler = (property, after = null, valueProperty = 'value') => {
    return event => {
      this.setState({
        [property]: event.target[valueProperty],
      });
      if (after) {
        after();
      }
    };
  };

  fetchCurrentArticle = slug => {
    let {formatMessage} = this.props.intl;

    articleApi.getArticle(slug).then(article => {
      this.setState({article});
    }).catch(error => {
      if (error.code === 404) {
        let article = {
          title: formatMessage({id: 'general.article.not.found'}),
          body: formatMessage({id: 'general.not.article.requested'}),
        };

        this.setState({article});
      } else {
        throw error;
      }
    });
  };

  filterChange = (text, submitted) => {
    this.setState({query: text});

    if (submitted) {
      session.setSearch(text, this.state.topic);
      window.location.hash = 'encyclopedia';
    }
  };

  render() {
    let {formatMessage} = this.props.intl;

    return <div className='page-encyclopedia-article container'>
      <Header mainTitle={formatMessage({id: 'encyclopedia.title'})}
              subTitle={this.state.article ? this.state.article.topic.Name : 'Article'}
              mainTitleReturn='encyclopedia'/>
      <div className='well clearfix'>
        <div className='col-sm-4'>
          <SearchField placeholder={formatMessage({id: 'general.search.articles.keyboards'})}
                       onSearch={this.filterChange}/>
        </div>
        <div className='col-sm-4'>
          <div className='form-group'>
            <select className='form-control'
                    value={this.state.topic}
                    onChange={this.changeHandler('topic', this.updateURL)}>
              <option value=''>{formatMessage({id: 'general.select.topic'})}</option>
              {this.state.topics.map(topic => <option key={topic.ID}
                                                      value={topic.Name}>{topic.Name}</option>)}
            </select>
          </div>
        </div>
      </div>

      <ArticleFav article={this.state.article}/>
      <ArticleContents article={this.state.article}
                       formatMessage={formatMessage}/>

      <PageFooter>
        <FooterButton label={formatMessage({id: 'general.print'})}
                      icon='bl bl-print fa-2x'
                      onClick={() => events.publish('print', <ArticleContents article={this.state.article}
                                                                              formatMessage={formatMessage}/>)}/>
        <EmailModal
          title='Article'
          target={this.state.article && this.state.article.id ? this.state.article.id : undefined}
          type={emailSendingTypes.encyclopedia}/>
      </PageFooter>
    </div>;
  }
}

const WrappedEncyclopediaArticlePage = injectIntl(EncyclopediaArticlePage);

export default WrappedEncyclopediaArticlePage;
